import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M2.49 4.49C4.095 2.885 6.23 2 8.5 2s4.405.884 6.01 2.49S17 8.23 17 10.5v1.293l2.146-2.146c.195-.195.512-.195.707 0s.195.512 0 .707l-3 3c-.098.098-.226.146-.354.146s-.256-.049-.354-.146l-3-3c-.195-.195-.195-.512 0-.707s.512-.195.707 0l2.146 2.146V10.5c0-4.136-3.364-7.5-7.5-7.5s-7.5 3.364-7.5 7.5 3.364 7.5 7.5 7.5c.276 0 .5.224.5.5s-.224.5-.5.5c-2.27 0-4.405-.884-6.01-2.49s-2.49-3.74-2.49-6.01c0-2.27.884-4.405 2.49-6.01z',
  ],
  height: 20,
  width: 20,
});
